import React, { useState } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import shivaDeekshith from '../../assets/Rehab staff/Shiva deekshith.JPG';
import maheshwari from '../../assets/Rehab staff/Maheshwari.JPG';
import saiKiran from '../../assets/Rehab staff/Sai kiran.JPG';

const teamMembers = [
  {
    name: 'R. Shiva Deekshith',
    role: 'Speech Therapist',
    bio: 'Dedicated to improving lives through effective communication.',
    image: shivaDeekshith,
  },
  {
    name: 'B. Maheshwari',
    role: 'Speech Therapist',
    bio: 'Passionate about helping individuals find their voice.',
    image: maheshwari,
  },
];

const sections = [
  {
    title: 'Our Services',
    items: [
      { title: 'Assessment and Diagnosis', content: 'Our SLPs conduct thorough evaluations to identify communication disorders, including speech sound disorders, language disorders, fluency disorders (stuttering), voice disorders, and swallowing disorders (dysphagia).' },
      { title: 'Individualized Treatment Plans', content: 'Based on the assessment results, our SLPs create personalized treatment plans tailored to each client\'s unique needs and goals.' },
      { title: 'Speech Therapy', content: 'We address a range of communication disorders with articulation, fluency, and voice therapy.' },
      { title: 'Language Therapy', content: 'Enhancing skills in comprehension, expression, reading, and writing for all age groups.' },
      { title: 'Swallowing Therapy (Dysphagia)', content: 'Specialized therapy to ensure safe and effective eating and drinking for those with swallowing disorders.' },
      { title: 'Augmentative and Alternative Communication (AAC)', content: 'We provide AAC devices and training for individuals with severe speech or language challenges.' },
      { title: 'Counseling and Support', content: 'Support for individuals and families in dealing with emotional and psychological impacts of communication disorders.' },
      { title: 'Group Therapy', content: 'Group sessions to enhance social communication, peer interaction, and confidence.' },
    ],
  },
  {
    title: 'Specialized Programs',
    items: [
      { title: 'Autism Spectrum Disorder (ASD) Program', content: 'We support individuals with ASD in improving communication, social skills, and behavioral regulation.' },
      { title: 'Stroke and Brain Injury Program', content: 'Targeted therapies for speech and swallowing difficulties following neurological injuries.' },
      { title: 'Pediatric Program', content: 'Early intervention for speech sound disorders, developmental delays, and language disorders.' },
    ],
  },
  {
    title: 'Why Choose Us?',
    items: [
      { title: 'Experienced SLPs', content: 'Our certified speech-language pathologists are trained in evidence-based approaches.' },
      { title: 'Comprehensive Care', content: 'We provide end-to-end support from diagnosis to therapy to family guidance.' },
      { title: 'Inclusive & Supportive Environment', content: 'We foster growth, confidence, and communication at every level.' },
    ],
  },
];

const SpeechTherapy = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <div>

      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Speech and Language Therapy Services</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Speech and Language at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            We provide comprehensive services for individuals with communication and swallowing disorders. Our experienced SLPs are dedicated to empowering individuals through personalized therapies, innovative approaches, and compassionate care.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.title}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to delivering world-class speech-language therapy with a patient-first approach. We empower individuals to communicate confidently and live more independently.
            </p>
          </section>

          <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To learn more about our <strong>Speech and Language Therapy Services</strong> or to schedule an appointment, click below and fill out our request form.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
      <Footer />
    </div>
  );
};

export default SpeechTherapy;
